"use client"

import Select from "react-select"

const DashboardHeader = ({
    counters,
    appliedStartDate,
    appliedEndDate,
    // Filter props
    startDate,
    endDate,
    selectedDestinations = [],
    selectedSkus = [],
    selectedCategories = [],
    selectedChannels = [],
    destinationOptions = [],
    skuOptions = [],
    categoryOptions = [],
    channelOptions = [],
    onStartDateChange,
    onEndDateChange,
    onDestinationsChange,
    onSkusChange,
    onCategoriesChange,
    onChannelsChange,
    onApplyFilters,
    onResetFilters,
    destinationType,
    onToggleDestinationType,
}) => {
    const formatDate = (dateStr) => {
        try {
            return new Date(dateStr).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
            });
        } catch (error) {
            return dateStr;
        }
    }

    // Custom components for showing selected count
    const MultiValue = ({ index, getValue, children }) => {
        const selected = getValue();
        if (index === 0) {
            if (selected.length === 1) {
                return (
                    <div style={{
                        backgroundColor: "#F6ECF1",
                        borderRadius: "6px",
                        padding: "2px 8px",
                        marginRight: "4px",
                        color: "#B9366D",
                        fontWeight: 600,
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                        display: "inline-block"
                    }}>
                        {children}
                    </div>
                );
            } else {
                return (
                    <div style={{
                        backgroundColor: "#F6ECF1",
                        borderRadius: "6px",
                        padding: "2px 8px",
                        marginRight: "4px",
                        color: "#B9366D",
                        fontWeight: 600,
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                        display: "inline-block"
                    }}>
                        {children}
                        {` +${selected.length - 1}`}
                    </div>
                );
            }
        }
        return null;
    }

    // Safe filter function to handle undefined arrays
    const getSelectedOptions = (options = [], selectedValues = []) => {
        if (!Array.isArray(options) || !Array.isArray(selectedValues)) {
            return [];
        }
        return options.filter(o => selectedValues.includes(o.value));
    }

    // Common styles for all Select components
    const selectStyles = {
        control: (base) => ({
            ...base,
            borderColor: "#e0e0e0",
            borderRadius: 8,
            border: "2px solid #e0e0e0",
            "&:hover": { cursor: "pointer" },
            minHeight: "40px",
            minWidth: 0,
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden"
        }),
        valueContainer: (base) => ({
            ...base,
            minWidth: 0,
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
            flexWrap: "nowrap"
        }),
        menu: (base) => ({
            ...base,
            backgroundColor: "white",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            zIndex: 9999,
        }),
        menuList: (base) => ({
            ...base,
            padding: "8px",
            backgroundColor: "white",
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
                ? "#B9366D"
                : state.isFocused
                ? "#F6ECF1"
                : "white",
            color: state.isSelected ? "white" : "#333",
            "&:hover": {
                backgroundColor: state.isSelected ? "#B9366D" : "#F6ECF1",
                color: state.isSelected ? "white" : "#333",
            },
            borderRadius: "4px",
            padding: "8px 12px",
            margin: "2px 0",
            fontWeight: state.isSelected ? 700 : 400,
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: "#F6ECF1",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: "#B9366D",
            fontWeight: "600",
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: "#B9366D",
            "&:hover": {
                backgroundColor: "#B9366D",
                color: "white",
            },
        }),
    }

    return (
        <div
            style={{
                color: "white",
                marginBottom: "24px",
            }}
        >
            {/* Top row with title and destination type */}
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginBottom: "20px" }}>
                {/* <div style={{ display: "flex", alignItems: "center" }}>
                    <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#333", margin: 0 }}>
                        Sales Dashboard
                    </h1>
                    <div style={{ 
                        background: "#F6ECF1", 
                        borderRadius: "6px", 
                        padding: "4px 12px", 
                        marginLeft: "12px",
                        color: "#B9366D",
                        fontWeight: "600",
                        fontSize: "13px"
                    }}>
                        {formatDate(appliedStartDate || '')} - {formatDate(appliedEndDate || '')}
                    </div>
                </div> */}
                
                <div style={{ position: "relative", width: "fit-content" }}>
                    <select
                        value={destinationType || "combination"}
                        onChange={(e) => onToggleDestinationType(e.target.value)}
                        style={{
                            padding: "10px 36px 10px 14px",
                            borderRadius: "8px",
                            border: "1px solid #d1d5db",
                            background: "#fff",
                            color: "#333",
                            fontWeight: 600,
                            fontSize: "14px",
                            cursor: "pointer",
                            appearance: "none",
                            minWidth: "200px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                            backgroundImage: `url("data:image/svg+xml;charset=US-ASCII,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'><path fill='%23BA386E' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>")`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "right 12px center",
                            backgroundSize: "10px 12px",
                            transition: "all 0.2s ease",
                        }}
                    >
                        <option value="combination" style={{ background: "#F7EEF2", padding: "8px", color: "#333", fontWeight: 500 }}>
                            Combination
                        </option>
                        <option value="darkstore" style={{ background: "#F7EEF2", padding: "8px", color: "#333", fontWeight: 500 }}>
                            Darkstores
                        </option>
                        <option value="warehouse" style={{ background: "#F7EEF2", padding: "8px", color: "#333", fontWeight: 500 }}>
                            Warehouses
                        </option>
                    </select>
                </div>
            </div>

            {/* Filters Row - 8 columns grid */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "minmax(200px, 240px) minmax(180px, 220px) minmax(180px, 220px) minmax(180px, 220px) minmax(150px, 180px) minmax(150px, 180px) minmax(120px, 140px) minmax(120px, 140px)",
                    gap: "14px",
                    alignItems: "end",
                }}
            >
                {/* Destination Filter */}
                <div style={{ minWidth: 0, maxWidth: "100%" }}>
                    <label style={{ fontSize: "12px", opacity: 0.9, marginBottom: "4px", color: "black", display: "block" }}>
                        Destination
                    </label>
                    <Select
                        isMulti
                        options={destinationOptions || []}
                        value={getSelectedOptions(destinationOptions, selectedDestinations)}
                        onChange={onDestinationsChange}
                        placeholder="ALL Destinations"
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                            MultiValue: (props) => <MultiValue {...props} />
                        }}
                        styles={selectStyles}
                    />
                </div>

                {/* SKU Category Filter */}
                <div>
                    <label style={{ fontSize: "12px", opacity: 0.9, marginBottom: "4px", color: "black", display: "block" }}>
                        SKU Category
                    </label>
                    <Select
                        isMulti
                        options={categoryOptions || []}
                        value={getSelectedOptions(categoryOptions, selectedCategories)}
                        onChange={onCategoriesChange}
                        placeholder="ALL Categories"
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                            MultiValue: (props) => <MultiValue {...props} />
                        }}
                        styles={selectStyles}
                    />
                </div>

                {/* Channel Filter */}
                <div>
                    <label style={{ fontSize: "12px", opacity: 0.9, marginBottom: "4px", color: "black", display: "block" }}>
                        Channel
                    </label>
                    <Select
                        isMulti
                        options={channelOptions || []}
                        value={getSelectedOptions(channelOptions, selectedChannels)}
                        onChange={onChannelsChange}
                        placeholder="ALL Channels"
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                            MultiValue: (props) => <MultiValue {...props} />
                        }}
                        styles={selectStyles}
                    />
                </div>

                {/* SKU Filter */}
                <div>
                    <label style={{ fontSize: "12px", opacity: 0.9, marginBottom: "4px", color: "black", display: "block" }}>
                        SKU
                    </label>
                    <Select
                        isMulti
                        options={skuOptions || []}
                        value={getSelectedOptions(skuOptions, selectedSkus)}
                        onChange={onSkusChange}
                        placeholder="ALL SKUs"
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                            MultiValue: (props) => <MultiValue {...props} />
                        }}
                        styles={selectStyles}
                    />
                </div>

                {/* From Date Filter */}
                <div>
                    <label style={{ fontSize: "12px", opacity: 0.9, marginBottom: "4px", color: "black", display: "block" }}>
                        From Date
                    </label>
                    <input
                        id="startDate"
                        type="date"
                        value={startDate || ''}
                        max={endDate || ''}
                        onClick={() => document.getElementById('startDate')?.showPicker?.()}
                        onChange={(e) => onStartDateChange && onStartDateChange(e)}
                        style={{
                            padding: "8px 12px",
                            borderRadius: 8,
                            border: "2px solid #e0e0e0",
                            fontSize: 14,
                            background: "#fff",
                            width: "100%",
                            minHeight: "40px",
                            transition: "border-color 0.2s",
                            outline: "none",
                            fontFamily: "inherit",
                        }}
                        onFocus={(e) => (e.target.style.borderColor = "#2684FF")}
                        onBlur={(e) => (e.target.style.borderColor = "#e0e0e0")}
                    />
                </div>

                {/* To Date Filter */}
                <div>
                    <label style={{ fontSize: "12px", opacity: 0.9, marginBottom: "4px", color: "black", display: "block" }}>
                        To Date
                    </label>
                    <input
                        id="endDate"
                        type="date"
                        value={endDate || ''}
                        min={startDate || ''}
                        onChange={(e) => onEndDateChange && onEndDateChange(e)}
                        onClick={() => document.getElementById('endDate')?.showPicker?.()}
                        style={{
                            padding: "8px 12px",
                            borderRadius: 8,
                            border: "2px solid #e0e0e0",
                            fontSize: 14,
                            background: "#fff",
                            width: "100%",
                            minHeight: "40px",
                            transition: "border-color 0.2s",
                            outline: "none",
                            fontFamily: "inherit",
                        }}
                        onFocus={(e) => (e.target.style.borderColor = "#2684FF")}
                        onBlur={(e) => (e.target.style.borderColor = "#e0e0e0")}
                    />
                </div>

                {/* Apply Button */}
                <div style={{ display: "flex", alignItems: "center" }}>
                    <button
                        onClick={onApplyFilters}
                        style={{
                            borderRadius: 6,
                            border: "none",
                            background: "linear-gradient(135deg, #B9366D 0%, #8B2B52 100%)",
                            color: "#fff",
                            fontWeight: 600,
                            fontSize: 14,
                            height: "40px",
                            cursor: "pointer",
                            width: "100%",
                            minWidth: "80px",
                            transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) => e.target.style.opacity = "0.9"}
                        onMouseOut={(e) => e.target.style.opacity = "1"}
                    >
                        Apply
                    </button>
                </div>

                {/* Reset Button */}
                <div style={{ display: "flex", alignItems: "center" }}>
                    <button
                        onClick={onResetFilters}
                        style={{
                            borderRadius: 6,
                            border: "1px solid #B9366D",
                            background: "#fff",
                            color: "#B9366D",
                            fontWeight: 600,
                            fontSize: 14,
                            height: "40px",
                            cursor: "pointer",
                            width: "100%",
                            minWidth: "80px",
                            transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) => {
                            e.target.style.background = "#F6ECF1";
                            e.target.style.borderColor = "#8B2B52";
                        }}
                        onMouseOut={(e) => {
                            e.target.style.background = "#fff";
                            e.target.style.borderColor = "#B9366D";
                        }}
                    >
                        Reset
                    </button>
                </div>
            </div>
        </div>
    )
}

// Default props
DashboardHeader.defaultProps = {
    counters: {},
    appliedStartDate: '',
    appliedEndDate: '',
    startDate: '',
    endDate: '',
    selectedDestinations: [],
    selectedSkus: [],
    selectedCategories: [],
    selectedChannels: [],
    destinationOptions: [],
    skuOptions: [],
    categoryOptions: [],
    channelOptions: [],
    destinationType: 'combination',
    onStartDateChange: () => {},
    onEndDateChange: () => {},
    onDestinationsChange: () => {},
    onSkusChange: () => {},
    onCategoriesChange: () => {},
    onChannelsChange: () => {},
    onApplyFilters: () => {},
    onResetFilters: () => {},
    onToggleDestinationType: () => {},
}

export default DashboardHeader